module.exports = __webpack_public_path__ + "img/festival-band.508d5b8e.jpg";